const ComparisonCards = () => {
  const installHeights = () => {
    const comparisonCards = [...document.querySelectorAll(".comparison__card")];

    if (comparisonCards.length > 1) {
      const card1Items = [...comparisonCards[0].querySelectorAll(".comparison__card-main-item")];
      const card2Items = [...comparisonCards[1].querySelectorAll(".comparison__card-main-item")];

      const card1Header = comparisonCards[0].querySelector(".comparison__card-header");
      const card2Header = comparisonCards[1].querySelector(".comparison__card-header");

      if (card1Items.length === card2Items.length) {
        card1Items.forEach((item, index) => {
          item.style.height = 'auto';
          card2Items[index].style.height = 'auto';

          const card1Height = item.offsetHeight;
          const card2Height = card2Items[index].offsetHeight;

          const maxHeight = Math.max(card1Height, card2Height);

          item.style.height = `${maxHeight}px`;
          card2Items[index].style.height = `${maxHeight}px`;
        });
      } else {
        console.error("Cards have a different number of items.");
      }

      if (card1Header && card2Header) {
        card1Header.style.height = 'auto';
        card2Header.style.height = 'auto';

        const card1HeaderHeight = card1Header.offsetHeight;
        const card2HeaderHeight = card2Header.offsetHeight;

        const maxHeaderHeight = Math.max(card1HeaderHeight, card2HeaderHeight);

        card1Header.style.height = `${maxHeaderHeight}px`;
        card2Header.style.height = `${maxHeaderHeight}px`;
      } else {
        console.error("One or both cards are missing headers.");
      }
    }
  };

  window.addEventListener('resize', installHeights);
  window.addEventListener('load', installHeights);
  
  installHeights();
};

export default ComparisonCards;

